import { createFileRoute } from "@tanstack/react-router"
import InboxTab from "~/components/product-management/tabs/InboxTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/inbox")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management - Inbox")
  return <InboxTab />
}
